/**
 * config.js
 *
 * ⚠️ SÉCURITÉ : Les clés API et hashes ne doivent PLUS être en clair ici.
 * Utilisez des variables d'environnement React (préfixe REACT_APP_).
 *
 * Pour l'API_KEY et api_hash : comme elles sont embarquées dans le bundle
 * frontend (donc visibles par n'importe quel utilisateur via F12), elles
 * ne doivent servir qu'à des usages NON sensibles (anti-spam basique, etc.).
 * Pour toute opération sensible, déplacez la logique côté backend.
 *
 * TODO (action manuelle requise) :
 * 1. Révoquer et régénérer API_KEY côté backend
 * 2. Ajouter les variables dans .env.local (et .env.production) :
 *      REACT_APP_SERVER_DOMAIN=https://apidlog.vps116834.serveur-vps.net
 *      REACT_APP_API_KEY=<nouvelle clé>
 *      REACT_APP_API_HASH=<nouveau hash>
 * 3. Ne JAMAIS committer .env.local (déjà dans .gitignore normalement)
 */

const config = {
  REACT_APP_SERVER_DOMAIN:
    process.env.REACT_APP_SERVER_DOMAIN ||
    'https://apidlog.vps116834.serveur-vps.net',

  // ⚠️ Ces deux valeurs doivent être chargées depuis l'environnement.
  // Si elles ne le sont pas (build sans .env), on avertit en console.
  API_KEY: process.env.REACT_APP_API_KEY || '',
  api_hash: process.env.REACT_APP_API_HASH || '',
};

if (!process.env.REACT_APP_API_KEY && process.env.NODE_ENV === 'development') {
  console.warn(
    '⚠️ config.js : REACT_APP_API_KEY non défini. ' +
      'Créez un fichier .env.local avec REACT_APP_API_KEY=<valeur>.'
  );
}
if (!process.env.REACT_APP_API_HASH && process.env.NODE_ENV === 'development') {
  console.warn(
    '⚠️ config.js : REACT_APP_API_HASH non défini. ' +
      'Créez un fichier .env.local avec REACT_APP_API_HASH=<valeur>.'
  );
}

export default config;
